<template>
  <div>
    <BaseDialog
        title="表示項目設定"
        :visible.sync="dialogVisible"
        width="700px"
        :append-to-body="true"
        @closed="close">
      <template slot="contents">
        <!-- 保存済みのリスト -->
        <BaseTableList
            ref="table"
            class="table"
            row-class-name="clickable"
            :table-set-list="_tableSetList"
            :display-items="displayItem"
            :filter-condition.sync="filterCondition"
            @sort-change="onSortChange"
            @row-dblclick="onRowDoubleClick">
          <template slot="slots"
              slot-scope="{ row }">
            <slot :name="'slots'"
                :row="row" />
          </template>
        </BaseTableList>
        <!-- ページネーション -->
        <div class="base-pagination">
          <el-pagination
              :current-page="currentPage"
              :page-size="10"
              :total="total"
              background
              layout="prev, pager, next, total"
              @current-change="onPaginationCurrentChange" />
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>
</style>
<script>

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseTableList from '@/components/molecules/BaseTableList'
import BaseDialog from '@/components/molecules/BaseDialog'
import common from '@/utils/common'
import message from '@/utils/message'
import * as define from '@/define'
import * as config from '@/config'
import _ from 'lodash'

export default {
  name: 'BaseDisplayListModal',
  components: {
    BaseTableList,
    BaseDialog
  },
  inject: ['parentValidator'],
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    storePath: {
      type: String,
      required: true
    },
    displayConfig: {
      type: Array,
      required: true,
      default: () => []
    },
    functionKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      displayConfigData: [],
      currentPage: 1,
      searchKey: '',
      dialogDisplayConfig: [],
      sortCondition: {},
      filterCondition: {}
    }
  },
  computed: {
    _tableSetList () {
      return [
        {
          type: 'String', label: '名前', path: 'name',
          sortable: 'custom', sortBy: 'name'
        },
        {
          type: 'String', label: '公開', elementType: ELEMENT_TYPE.FUNCTION,
          path: (row) => row.account ? '個人' : '公開', width: '150px',
          columnKey: 'isPublic', name: 'isPublic',
          filters: [ { text: '個人', value: 0 }, { text: '公開', value: 1 } ],
          sortable: 'custom', sortBy: (row) => row.account ? 0 : 1
        },
        {
          type: 'String', elementType: ELEMENT_TYPE.CELL, width: '250px',
          properties: [{
            elementType: ELEMENT_TYPE.BUTTON,
            label: '削除', class: 'right',
            click: this.deleteDisplayConfig
          }],
          value: '',
          renderHeader: (h, { _self }) => {
            return h('input',
              {
                class: 'el-input__inner',
                attrs: { placeholder: 'フィルター' },
                domProps: {
                  value: _self.$parent.$parent.$parent.searchKey
                },
                on: {
                  input (e) {
                    _.set(_self, '$parent.$parent.$parent.searchKey', e.target.value)
                  }
                },
                props: {
                  level: {
                    type: Number,
                    required: true
                  }
                }
              }
            )
          }
        }
      ]
    },
    total () {
      return this.filteredItem.length
    },
    filteredItem () {
      const keywords = this.searchKey
        // 全角スペースは半角に変換
        // eslint-disable-next-line no-irregular-whitespace
        .replace(/　/g, ' ')
        .split(' ')
        .filter((str) => str !== '')
      let filteredValue = _.get(this.$refs, 'table.$refs.table.columns[1].filteredValue', null)
      if (filteredValue == null) {
        _.set(this.$refs, 'table.$refs.table.columns[1].filteredValue', [])
        filteredValue = []
      }
      const returnValue = this.displayConfigData.filter((data) => {
        // 公開/個人でのフィルター
        if ((filteredValue.includes(0) && !filteredValue.includes(1) && data.account == null) ||
          (!filteredValue.includes(0) && filteredValue.includes(1) && data.account != null)) {
          return false
        }

        // 検索キーワードでのフィルター
        return keywords.length === 0 ? true : keywords.some((keyword) => {
          return data.name.indexOf(keyword) !== -1
        })
      })
      return common.sortListData(returnValue, this.sortCondition)
    },
    displayItem () {
      const maxPage = Number.parseInt(this.filteredItem.length / 10) + 1
      if (maxPage < this.currentPage) {
        _.set(this, 'currentPage', maxPage)
      }
      const head = (this.currentPage - 1) * 10
      return this.filteredItem.slice(head, head + 10)
    }
  },
  watch: {
    async visible (val) {
      if (val) {
        this.$loadingService.show()
        try {
          // データ取得
          this.displayConfigData = await common.getDisplayConfigs(this.functionKey)
          this.dialogVisible = val

          // 表示時にfilteredValueがないため、filterの変更によるcomputedの再計算が行われないため、一度コードで再計算させる
          const tempKeyword = this.searchKey
          this.searchKey = ' '
          setTimeout(() => {
            this.searchKey = tempKeyword
          }, 1)
        } finally {
          this.$loadingService.close()
        }
      }
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    input: function (value) {
      this.model = value
    },
    close () {
      this.dialogVisible = false
    },
    async deleteDisplayConfig (row, displayItem) {
      this.$confirm('表示項目を削除しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // APIコール
          const url = config.DISPLAY_ITEM + `/${displayItem.uuid}`
          const method = 'delete'

          await common.apiAxios(url, { method })
          this.$notify.success('削除しました。')
          // 削除対象のデータを消す
          const deleteIndex = this.displayConfigData.findIndex((data) => data.uuid === displayItem.uuid)
          this.displayConfigData.splice(deleteIndex, 1)
        } catch (error) {
          common.addError(error, { msg: message.MSG_549() })
          this.$notify.error({ error: error })
        } finally {
          this.$loadingService.close()
        }
      }).catch((error) => {
        if (error === 'cancel') this.$notify.info('キャンセルしました。')
      })
    },
    onRowDoubleClick (row) {
      // 設定を反映
      const saveVal = this.displayConfig.map((data) => {
        const item = row.items.find((item) => item.displayItem.itemKey === data.itemKey)
        if (item) {
          data.isDisplay = true
        } else {
          data.isDisplay = false
        }
        return data
      })

      common.saveDisplay(this.functionKey, saveVal)

      this.$store.dispatch({
        type: 'set',
        states: {
          [`${this.storePath}/displayItems`]: saveVal
        }
      })
      // ダイアログを閉じる
      this.close()
    },
    filterPublicMethod (value, row) {
      if (value) {
        return row.account == null
      } else {
        return row.account != null
      }
    },
    onPaginationCurrentChange (val) {
      this.currentPage = val
    },
    onSortChange ({ column, prop, order }) {
      this.sortCondition = {
        // isPublicは、FUNCTIONタイプの並び替えをするためにname(prop)を設定しないようにする必要があるが、
        // フィルターでnameが必要なのでここで判定して設定する値を判定する
        prop: prop === 'isPublic' ? null : prop,
        order,
        sortBy: (!column || !column.sortBy) ? null : column.sortBy
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organisms/BaseDisplayListModal.vue